export default "__VITE_ASSET__BQmRUe7___"